<template>
  <lwf-autocomplete
    :value="value"
    v-bind="mergedProps"
    v-on="$listeners"
  >
    <template
      v-for="(slot, k) in $slots"
      #[k]
    >
      <slot :name="k" />
    </template>
    <template
      v-for="(slot, k) in $scopedSlots"
      #[k]="props"
    >
      <slot
        :name="k"
        v-bind="props"
      />
    </template>
  </lwf-autocomplete>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import LwfAutocomplete from 'components/core/LwfAutocomplete'
import propsReadonly from '@/mixins/propsReadonly'
import validateProxyMixin from '@/mixins/validateProxyMixin'

const storeUser = createNamespacedHelpers('user')
const storeUserAgency = createNamespacedHelpers('user/agency')
/**
 * Autocomplete pour les spécialités
 */
export default {
  name: 'AutocompleteSpecialite',
  components: { LwfAutocomplete },
  mixins: [propsReadonly, validateProxyMixin],
  inheritAttrs: false,
  props: {
    /**
     * @model
     */
    value: {
      type: [String, Object, Array],
      default: undefined
    },
    site: {
      type: [String, Object, Array],
      default: undefined
    },
    multiple: Boolean
  },
  computed: {
    ...storeUser.mapGetters({
      company: 'company'
    }),
    ...storeUserAgency.mapGetters({
      getSite: 'getSite'
    }),
    siteSlug () {
      const { site } = this
      return _.isObject(site) ? site.slug : site
    },
    companySpecialties () {
      return this.company.specialties
    },
    specialties () {
      const { siteSlug } = this
      return siteSlug
        ? _.get(this.getSite(siteSlug), ['specialties'], []).map((s) => s.specialty)
        : this.companySpecialties
    },
    mergedProps () {
      const { siteSlug, companySpecialties, specialties, multiple, readonly } = this
      const noSiteSpecialities = siteSlug && specialties.length === 0
      const options = noSiteSpecialities
        ? companySpecialties
        : specialties
      return {
        label: `${_.upperFirst(this.$APP.words.specialty)}${multiple ? '(s)' : ''}`,
        optionValue: 'id',
        ...this.$attrs,
        options,
        multiple,
        readonly,
        hint: noSiteSpecialities && !readonly ? `Le site n'a pas de ${this.$APP.words.specialty}s` : this.$attrs.hint
      }
    }
  },
  watch: {
    siteSlug: {
      immediate: true,
      handler (_siteSlug) {
        const { value, readonly } = this
        const _v = _.isObject(value)
          ? value.id
          : value
        if (_v && !readonly && !this.specialties.find((o) => o.id === _v)) {
          this.$emit('input', null)
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
